import { render } from "./FirstSectionKuhul.vue?vue&type=template&id=edb36048&scoped=true"
import script from "./FirstSectionKuhul.vue?vue&type=script&lang=js"
export * from "./FirstSectionKuhul.vue?vue&type=script&lang=js"

import "./FirstSectionKuhul.vue?vue&type=style&index=0&id=edb36048&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edb36048"]])

export default __exports__